// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"6b2914d0","16":"67405fa6","481":"6cbc3f68","556":"93ae900b","836":"f7b4964d","889":"b53bc896","894":"645445d7","988":"9bc2567f"}[chunkId] + ".chunk.css";
};